module.exports = __webpack_public_path__ + "static/img/11.7f80b56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/11.png
// module id = ktML
// module chunks = 0